import { Capacitor } from '@capacitor/core'
import * as Sentry from '@sentry/browser'
import React from 'react'
import { createRoot } from 'react-dom/client'
import '../processEnv'

const start = async () => {
  const [
    { default: AppRouterProvider },
    { default: UIContext },
    { default: getSentryConfig },
    { default: AppRoot },
    { resolveLocale },
    { default: VitiMapEntry },
  ] = await Promise.all([
    import('system/Router/provider'),
    import('system/UIContext'),
    import('system/getSentryConfig'),
    import('../shared/appRoot'),
    import('../shared/resolveLocale'),
    import('./VitiMapEntry'),
  ])

  if (!Capacitor.isNativePlatform()) {
    Sentry.init(getSentryConfig('browser'))
  }

  const { locale } = await resolveLocale()
  const root = document.querySelector('#root')
  if (!root) throw new Error('Missing root element')

  createRoot(root).render(
    <AppRoot locale={locale}>
      <AppRouterProvider>
        <UIContext>
          <VitiMapEntry />
        </UIContext>
      </AppRouterProvider>
    </AppRoot>,
  )
}

void start()
